import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from './api.service';
import dayjs from 'dayjs/esm';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private _api = inject(ApiService);

  notifications: any = signal([]);
  notification_count = signal(0);
  apiCalled = signal(false);

  getAllNotifications() {
    if(this.apiCalled()) return;
    this.apiCalled.set(true);
    this._api.getNotifications().subscribe({
      next: (res: any) => {
        if (res?.response?.notifications?.length > 0) {
          res.response.notifications.forEach((notification: any) => {
            notification.time = dayjs(notification.created_at).fromNow();
          });
          this.notification_count.set(res?.response?.sent || 0);
        }
        this.notifications.set(res?.response?.notifications || []);
      },
    });
  }

  updateNotifications() {
    if (this.notification_count() == 0) return;
    this._api.updateNotifications().subscribe();
  }
}
